import http from './http'
import { getMediaOrigin } from './config'

let bannersCache = null
let bannersPromise = null

function unwrapList(payload) {
  if (payload == null) return []
  if (Array.isArray(payload)) return payload
  const d = payload.data
  if (Array.isArray(d)) return d
  if (d && typeof d === 'object' && Array.isArray(d.data)) return d.data
  if (Array.isArray(payload.list)) return payload.list
  return []
}

function resolveMediaUrl(path) {
  if (!path || typeof path !== 'string') return ''
  const t = path.trim()
  if (!t) return ''
  // 与产品/方案封面一致：可访问地址为 /uploads/...，不要 /storage/uploads/...（否则会 404）
  if (/^https?:\/\//i.test(t) || t.startsWith('//') || t.startsWith('data:')) {
    if (/\/storage\/uploads/i.test(t)) return t.replace(/\/storage\/uploads/ig, '/uploads')
    return t
  }
  const base = getMediaOrigin().replace(/\/$/, '')
  if (t.startsWith('/storage/uploads') || t.startsWith('storage/uploads')) {
    const rest = t.replace(/^\/?storage\//, '')
    return `${base}/${rest.replace(/^\//, '')}`
  }
  if (t.startsWith('/storage/') || t.startsWith('storage/')) {
    const p = t.startsWith('/') ? t : `/${t}`
    return `${base}${p}`
  }
  if (t.startsWith('/uploads/') || t.startsWith('uploads/')) {
    const p = t.startsWith('/') ? t : `/${t}`
    return `${base}${p}`
  }
  return `${base}/${t.replace(/^\//, '')}`
}

function normalizeBanner(raw, index) {
  const image =
    raw.image ||
    raw.cover ||
    raw.pic ||
    raw.img ||
    raw.image_url ||
    raw.imageUrl ||
    raw.src ||
    raw.banner_url ||
    raw.bannerUrl ||
    ''

  const title = raw.title || raw.name || raw.headline || ''
  const subtitle =
    raw.subtitle || raw.description || raw.desc || raw.summary || raw.intro || ''
  const tag = raw.tag || raw.label || raw.category || raw.subtitle_tag || ''

  const link = raw.link || raw.url || raw.href || raw.target_url || '#'
  const primaryLabel =
    raw.button_text ||
    raw.buttonText ||
    raw.primary_label ||
    raw.primaryLabel ||
    '了解更多'
  const secondaryLabel =
    raw.secondary_button_text || raw.secondaryLabel || raw.secondary_text || ''
  const secondaryHref =
    raw.secondary_link || raw.secondaryHref || raw.secondary_url || '#products'

  return {
    key: String(raw.id ?? raw.banner_id ?? index),
    image: resolveMediaUrl(image),
    tag,
    title,
    subtitle,
    primaryLabel,
    primaryHref: link || '#',
    secondaryLabel: secondaryLabel || '',
    secondaryHref: secondaryHref || '#'
  }
}

/**
 * 门户轮播：GET /api/v1/banners（与后台管理同一套接口）
 * @returns {Promise<Array<ReturnType<typeof normalizeBanner>>>}
 */
export async function fetchBanners() {
  if (Array.isArray(bannersCache)) return bannersCache.map((i) => ({ ...i }))
  if (bannersPromise) return bannersPromise.then((list) => list.map((i) => ({ ...i })))

  bannersPromise = http
    .get('/api/v1/banners')
    .then(({ data }) => unwrapList(data).map((item, i) => normalizeBanner(item, i)))
    .then((list) => {
      bannersCache = list
      return list
    })
    .finally(() => {
      bannersPromise = null
    })

  return bannersPromise.then((list) => list.map((i) => ({ ...i })))
}
